import React, {Component} from 'react';
import {connect} from 'react-redux'
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';
import ExitToAppIcon from 'material-ui/svg-icons/action/exit-to-app';
import {isAuthenticated} from "../store/auth/utils";
import {logout} from "../store/auth/actions";
import {BREAKPOINT_SMALL} from "config";
import Drawer from 'components/Drawer';
import $ from 'jquery';
import {translate} from "react-i18next";



const Logged = (props) => (
    <IconButton tooltip={props.t("settings_sign_out_button")} onClick={props.signOutOnClick} ><ExitToAppIcon/></IconButton>
);

const TransLogged = translate()(Logged);

const Login = (props) => (
    <span/>
);


class Bar extends Component {
    constructor() {
        super();
        this.state = {
            showHamburger:false,
            openDrawer: true,
            barWidth: '100%'
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    componentWillMount() {
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        const w = window.innerWidth;
        let showHamburger = false;
        let openDrawer = true;
        if (w <= BREAKPOINT_SMALL) {
            showHamburger = true;
            openDrawer = false;
        }
        this.setState({
            showHamburger: showHamburger,
            openDrawer: openDrawer,
            barWidth: showHamburger ? $(window).width() : $(window).width() - 256 // width of drawer
        })
    };

    toggleDrawer = () => {
        if (this.state.showHamburger === true) {
            this.setState({
                openDrawer: !this.state.openDrawer
            })
        }
    };


    render() {
        if (this.props.path === '/login/' || this.props.path === '/login') {
            return null;
        }
        return (
            <span>
            <Drawer className="minerDrawer" handleClose={this.toggleDrawer} onRequestChange={(openDrawer) => this.setState({openDrawer})} open={this.state.openDrawer} docked={!this.state.showHamburger}/>
            <AppBar className="minerBar" style={{position: 'fixed', width: this.state.barWidth}}
                    iconElementLeft={this.state.showHamburger ? <IconButton iconStyle={{fill: '#000'}}><NavigationMenu/></IconButton>: <span />}
                    iconElementRight={this.props.isAuthenticated ? <TransLogged signOutOnClick={this.props.logout}/> : <Login/>}
                    onLeftIconButtonClick={this.toggleDrawer}
            />
            </span>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state.auth),
        path: state.router.location.pathname
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            return dispatch(logout());
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Bar);


// WEBPACK FOOTER //
// ./src/components/Bar.js